// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The ILabIconManager token.
 */
export const ILabIconManager = new Token('@jupyterlab/ui-components:ILabIconManager');
//# sourceMappingURL=tokens.js.map